import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import React, { useState } from "react";
import {
  PlanoPagamento,
  Carencia,
  NumeroParcelas,
} from "../../../types/AbaPlanoPagamento";
import { InputNumerico } from "../../inputs/InputNumerico";
const estiloSimularFinanciamento = require("./simular-financiamento.module.scss").default;
const estilosFormulario = require('app/estilos/formulario.module.scss').default
const estilosBotoes = require('app/estilos/botoes.module.scss').default
import * as R from 'ramda'

export type SimularFinanciamentoFormulario = {
  CodigoCarencia?: number;
  CodigoParcela?: number;
  CodigoPlanoPagamento?: number;
  ValorEntrada?: number;
  ValorFinanciado?: number;
  ValorParcela?: number;
};



export type SimularFinanciamentoProps = {
  simularFinanciamentoFormulario: SimularFinanciamentoFormulario;
  planosPagamento: PlanoPagamento[];
  numerosParcelas: NumeroParcelas[];
  carencias: Carencia[];
  onCalcular: (simularFinanciamentoFormulario: SimularFinanciamentoFormulario) => void;
  onErrorValidacao: (planoDePagamento: FormikErrors<SimularFinanciamentoFormulario>) => void;
  valorAtivadoDefault: boolean
  onPlanoPagamentoSelecionado: (codigoPlanoPagamento:string) => void
  onNumeroParcelasModificado: (codigoNumeroParcelas:number) => void
};

export const SimularFinanciamento = (props: SimularFinanciamentoProps) => {
  const [validado, setValidado] = useState(false);
  const [tipoDeCalculo, setTipoDeCalculo] = useState<"VALOR_PARCELAS" | "VALOR_FINANCIADO">("VALOR_PARCELAS")

  const formik = useFormik({
    initialValues: { ...props.simularFinanciamentoFormulario },
    onSubmit: (values, {}) => {},
    enableReinitialize: true,
    validate: (values) => {
      
      const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`

      return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
        CodigoPlanoPagamento: globalMU.isNullOrEmpty(values.CodigoPlanoPagamento) ? mensagemObrigatorio("CodigoPlanoPagamento") : null,
        CodigoParcela: globalMU.isNullOrEmpty(values.CodigoParcela) ? mensagemObrigatorio("CodigoParcela") : null,
        CodigoCarencia: globalMU.isNullOrEmpty(values.CodigoCarencia) ? mensagemObrigatorio("CodigoCarencia") : null,
        ValorParcela: tipoDeCalculo == "VALOR_FINANCIADO" && globalMU.isNullOrEmptyOrZero(values.ValorParcela) ? mensagemObrigatorio("ValorParcela") : null,
        ValorFinanciado: tipoDeCalculo == "VALOR_PARCELAS" && globalMU.isNullOrEmptyOrZero(values.ValorFinanciado) ? mensagemObrigatorio("ValorFinanciado") : null
      } as FormikErrors<SimularFinanciamentoFormulario>) 

    },
  })

  const planoPagamentoSelect = <>
    <label>
      Plano de Pagamento
      <span className={estilosFormulario.obrigatorio}>*</span>
    </label>
    <select
      className={`${validado && formik.errors.CodigoPlanoPagamento != undefined ? estilosFormulario.inputComErro : null}`}
      name="CodigoPlanoPagamento"
      value={formik.values.CodigoPlanoPagamento ?? ""}
      onChange={(e) => {
        formik.setFieldValue("CodigoPlanoPagamento", e.target.value)
        props.onPlanoPagamentoSelecionado(e.target.value)
      }}
    >
      <option value="">Selecione</option>
      {props.planosPagamento?.map((value) => (
        <option
          key={value.Codigo}
          value={value.Codigo}
        >
          {value.Nome}
        </option>
      ))}
    </select>
  </>

  const numeroParcelasSelect = <>
    <label>
      Nº de parcelas
      <span className={estilosFormulario.obrigatorio}>*</span>
    </label>
    <select
      className={`${validado && formik.errors.CodigoParcela != undefined ? estilosFormulario.inputComErro : null}`}
      name="CodigoParcela"
      value={formik.values.CodigoParcela ?? ""}
      onChange={(e) => {
        formik.handleChange(e);
        formik.setFieldValue("CodigoParcela", Number(e.target.value))
        props.onNumeroParcelasModificado(Number(e.target.value))
      }}
    >
      <option value="">Selecione</option>
      {props.numerosParcelas?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Quantidade}
        </option>
      ))}
    </select>
  </>

  const diasCarenciaSelect = <>
    <label>
      Dias de Carência
      <span className={estilosFormulario.obrigatorio}>*</span>
    </label>
    <select
      className={`${validado && formik.errors.CodigoCarencia != undefined ? estilosFormulario.inputComErro : null}`}
      name="CodigoCarencia"
      value={formik.values.CodigoCarencia ?? ""}
      onChange={formik.handleChange}
    >
      <option value="">Selecione</option>
      {props.carencias?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Dias}
        </option>
      ))}
    </select>
  </>

  const valorEntradaInput = <>
    <label>Valor Entrada</label>
    <InputNumerico
        onValorModificado={(valor) =>
          formik.setFieldValue("ValorEntrada", valor)
        }
        valor={formik.values.ValorEntrada || 0}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        campoNullavel={true}
      />
  </>

  const tipoCalculoCheckboxes = <>
    <label>Tipo de Cálculo</label>

    <div className="_flex _flex-row _gap-4">
      <div>
        <input
          type="radio"
          name="TipoCalculo"
          value="ValorParcela"
          checked={tipoDeCalculo == "VALOR_PARCELAS"}
          onChange={() => {
            setTipoDeCalculo("VALOR_PARCELAS")
            formik.setFieldValue("ValorParcela", 0)
          }}
        />
        Valor de Parcelas
      </div>

      <div>
        <input
          type="radio"
          name="TipoCalculo"
          value="ValorFinanciado"
          checked={tipoDeCalculo == "VALOR_FINANCIADO"}
          onChange={() => {
            setTipoDeCalculo("VALOR_FINANCIADO")
            formik.setFieldValue("ValorFinanciado", 0)
          }}
        />
        Valor Financiado
      </div>
    </div>
  </>

  const valorFinanciadoInput = <>
    <label>
      Valor Financiado
      {tipoDeCalculo == "VALOR_PARCELAS" && <span className={estilosFormulario.obrigatorio}>*</span>}
    </label>
    <InputNumerico
        onValorModificado={(valor) =>
          formik.setFieldValue("ValorFinanciado", valor)
        }
        valor={formik.values.ValorFinanciado || 0}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        campoNullavel={true}
        disabled={tipoDeCalculo == "VALOR_FINANCIADO"}
      />
  </>

  const valorParcelaInput = <>
    <label>
      Valor de Parcelas
      {tipoDeCalculo == "VALOR_FINANCIADO" && <span className={estilosFormulario.obrigatorio}>*</span>}
    </label>

    <InputNumerico
        onValorModificado={(valor) =>
          formik.setFieldValue("ValorParcela", valor)
        }
        valor={formik.values.ValorParcela || 0}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        campoNullavel={true}
        disabled={tipoDeCalculo == "VALOR_PARCELAS"}
      />
  </>

  const botaoCalcular = <>
    <button
      className={estilosBotoes.botaoPrimario}
      onClick={async () => {
        const erros = await formik.validateForm(formik.values)

        if (Object.keys(erros).length == 0) {
          props.onCalcular(formik.values)
        } else {
          props.onErrorValidacao(erros)
        }
        
        setValidado(true);
      }}
    >
      Calcular
    </button>
  </>

  return (
    <>
      <fieldset>
        <div>
          <div className={estiloSimularFinanciamento.separador} />

          <div
            className={estilosFormulario.formulario}
          >
            {planoPagamentoSelect}

            {numeroParcelasSelect}

            {diasCarenciaSelect}

            {valorEntradaInput}

            {tipoCalculoCheckboxes}

            {valorFinanciadoInput}

            {valorParcelaInput}

          </div>
        </div>
      </fieldset>
      <div>
        {botaoCalcular}
      </div>
    </>
  );
};
